import { render, staticRenderFns } from "./menulist.vue?vue&type=template&id=0a64cfaa&"
import script from "./menulist.vue?vue&type=script&lang=js&"
export * from "./menulist.vue?vue&type=script&lang=js&"
import style0 from "./menulist.vue?vue&type=style&index=0&id=0a64cfaa&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports